import React from 'react';
import { faCalendarClock, faTicket } from '@fortawesome/pro-regular-svg-icons';
import { SelectDropdown, SelectDropdownOption } from 'components/UI/V3/SelectDropdown/SelectDropdown';

export interface EnrollmentUsageSelection {
    expiresWithinDays?: number;
    maxRemainingUses?: number;
}

interface EnrollmentUsageFiltersProps {
    value: EnrollmentUsageSelection;
    onChange: (value: EnrollmentUsageSelection) => void;
}

type Option = SelectDropdownOption<number | null>;

const EXPIRATION_OPTIONS: Option[] = [
    { id: null, label: 'Any expiration' },
    { id: 30, label: 'Expires within 30 days' },
    { id: 60, label: 'Expires within 60 days' },
    { id: 90, label: 'Expires within 90 days' }
];

const REMAINING_USES_OPTIONS: Option[] = [
    { id: null, label: 'Any remaining uses' },
    { id: 0, label: 'Packages with 0 uses left' },
    { id: 1, label: 'Packages with 1 use or less' },
    { id: 2, label: 'Packages with 2 uses or less' },
    { id: 3, label: 'Packages with 3 uses or less' },
    { id: 5, label: 'Packages with 5 uses or less' }
];

const findOption = (options: Option[], id: number | undefined) =>
    options.find(option => option.id === (id ?? null)) ?? options[0];

const EnrollmentUsageFilters: React.FC<EnrollmentUsageFiltersProps> = ({ value, onChange }) => (
    <>
        <SelectDropdown<number | null>
            options={EXPIRATION_OPTIONS}
            value={findOption(EXPIRATION_OPTIONS, value.expiresWithinDays)}
            onChange={option => onChange({ ...value, expiresWithinDays: option?.id ?? undefined })}
            buttonProps={{ 'variant': 'outlined', 'leftIcon': faCalendarClock, 'aria-label': 'Expiration filter' }}
        />
        <SelectDropdown<number | null>
            options={REMAINING_USES_OPTIONS}
            value={findOption(REMAINING_USES_OPTIONS, value.maxRemainingUses)}
            onChange={option => onChange({ ...value, maxRemainingUses: option?.id ?? undefined })}
            buttonProps={{ 'variant': 'outlined', 'leftIcon': faTicket, 'aria-label': 'Remaining uses filter' }}
        />
    </>
);

export default EnrollmentUsageFilters;
